<template>
  <layout-editor-page
    :title="formTitle"
    :isLoading="isLoading"
    :isVisible="isVisible"
    :isBack="hasCreateNew"
    :isCancel="!hasCreateNew"
    @command="setCommandWrap"
  >
    <template v-slot:top-controls>
      <template v-if="hasCreateNew">
        <div class="control btn-mobile-full">
          <button class="btn btn-size-s" @click="isVisibleDialog = true" :disabled="isLoading">
            {{L10n('duplicate')}}
          </button>
        </div>
        <div class="control btn-mobile-full">
          <button class="btn btn-size-s" @click="handleOpenRepairStatus" :disabled="canOpenRepairStatus">
            {{L10n('open-repair-status')}}
          </button>
        </div>
      </template>
    </template>
    <template v-slot:top-tools v-if="hasCreateNew">
      <slot />
    </template>
    <form-editor
      ref="Form"
      :disabled="disabled"
      :data="data"
      :model="formModel"
      :hasCreateNew="hasCreateNew"
      @open-file="handleOpenFile"
      @onAutoSave="mixAutoSave"
      @change="handleFormData"
      @updateViewData="handleViewData"
    />
    <template v-slot:footer>
      <form-controls
        class="form-footer"
        :isCreate="!hasCreateNew && !disabled"
        :isSave="hasCreateNew && !disabled"
        :isDelete="false"
        @command="setCommandWrap">
        <div v-if="hasCreateNew" class="control btn-mobile-full" style="order: 1">
          <ui-button
            v-if="isAvailableToEditRFQs"
            class="btn btn-size-s btn-mobile-full"
            :class="data.statusID === 6 ? 'btn-red' : ''"
            :disabled="data.statusID !== 1"
            @click="handlerQuickRFQ"
          >
            {{L10n('quick-rfq')}}
          </ui-button>
        </div>
      </form-controls>
    </template>
    <dialog-connect-wo
      ref="dialog-connect-wo"
      filterFieldName="partID"
      :filterValueTemplate="filterValueTemplate"
    />
    <dialog-status-repair-order />
    <dialog-new-instruction-repair-order/>
    <dialog-duplicate
      :stockID="data.id"
      :isVisible.sync="isVisibleDialog"
      @onDuplicateSuccess="$emit('onDuplicateSuccess', $event)"
    />
  </layout-editor-page>
</template>

<script>

import FormWrapper from '@/components/Form/FormWrapper'
import { ModelStock } from '@/services/Stocks'
import OpenFile from '@/modules/OpenFile'
import { AutoSaveMixin } from '@/mixins/FormAutoSave'

export default {
  name: 'EditorStock',
  mixins: [FormWrapper, AutoSaveMixin],
  components: {
    'dialog-connect-wo': () => import(/* webpackChunkName: 'DialogConnectWo' */ '@/components/Shared/ActivityDialogConnectToOpenWO/Index'),
    'dialog-status-repair-order': () => import(/* webpackChunkName: 'DialogStatusRepairOrder' */ '@/components/Shared/ActivityDialogStatusEmailRepairOrder'),
    'dialog-new-instruction-repair-order': () => import(/* webpackChunkName: 'DialogNewInstructionRepairOrder' */ '@/components/Shared/ActivityDialogNewInstructionRepairOrder'),
    'form-editor': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/Stock/form.vue'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls'),
    'dialog-duplicate': () => import(/* webpackChunkName: 'Stock' */ './DialogDuplicate')
  },
  data () {
    return {
      isVisibleDialog: false
    }
  },
  computed: {
    isAvailableToSave () {
      return this.hasCreateNew
    },
    apiAutoSave () {
      return `Stocks/Patch/${this.currentID}`
    },
    canOpenRepairStatus () {
      const { partID, partSN } = this.formData
      return !(partID && partSN)
    },
    currentUser () {
      return this.$store.getters.get('currentUser')
    },
    formTitle () {
      let result = []
      this.viewData.partNumber && result.push(this.viewData.partNumber)
      this.formData.partSN && result.push(this.formData.partSN)
      return result.join(' - ') || this.checkEs6AndRun(this.title)
    },
    isAvailableToEditRFQs () {
      return this.permission(this.$store.getters.get('permissions'), 'isAllowToEditRFQs')
    }
  },
  methods: {
    filterValueTemplate (partID) {
      const { partSN } = this.formData
      if (!partID) {
        return Promise.reject(new Error(`part is expected`))
      }
      if (!partSN) {
        return Promise.reject(new Error(`partSN is expected`))
      }
      return Promise.resolve(`partID == ${partID} && partSN == "${partSN}"`)
    },
    handleOpenRepairStatus () {
      const { partSN, partID } = this.formData
      this.$refs['dialog-connect-wo'].show({ partSN, partID })
    },
    formModel () {
      return new ModelStock()
    },
    handleOpenFile (formValue) {
      OpenFile.open(this.currentUser, formValue)
    },
    handlerQuickRFQ () {
      this.$emit('on-quick-rfq', { row: { id: this.data.id, partID: this.formData.partID } })
    },
    setCommandWrap (command) {
      return this.setCommand(command)
    }
  }
}
</script>
